module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('strong', [_c('em', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('strong', [_c('em', [_vm._v("S")])])]), _vm._v("aturday morning, I sit up front with Mom as we drive to the farmer’s market with Quinn, my six-year-old brother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got a lot to get today,” she says. “You boys have to help carry the bags.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll need doughnuts first,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doughnuts, doughnuts,” Quinn echoes from the back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, you can each get a doughnut.” Mom stops at a light and checks her face in the mirror. She puckers her lips and dabs at a spot of lipstick. “I’m making a special dinner tomorrow night for Ted’s birthday. Heather and Haley will come, too. I want everything to be perfect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I check the street for a parking spot. That’s the best reason yet to go to soccer camp. I won’t have to be here for Mom’s boyfriend’s birthday and pretend to be nice to his girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("“There’s one.” I point to a silver pickup pulling out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom backs in smoothly. She opens her door and takes a deep breath. “I can already smell flowers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I step onto the sidewalk. All I smell is exhaust from the old truck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ahead of us, two dogs, one big and one small, sniff around each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A wiener dog.” Quinn points. “Can I pet him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ask the owner first,” Mom says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quinn runs up to a short bald man who seems pleased Quinn chose his dog over the German shepherd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you excited about soccer camp?” Mom presses the remote to lock the doors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, kind of. But Gig’s not coming.” I kick a stone on the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. He’s acting weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that’s too bad, but I’m sure you’ll have a good time anyway. Saint Boniface is supposed to be a beautiful campus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kick the stone again and it skids along the concrete and narrowly misses the wiener dog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s enough, Jackson,” Mom warns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("“You like dogs, don’t you?” the bald guy says to Quinn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love dogs!” Quinn rubs the wiener dog behind the ears. “But my mommy’s allergic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s too bad,” the man says, as he looks at Mom and me and then back to Quinn like that’s the saddest thing in the history of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve got to get going,” Mom says. Across the street, tables of the farmer’s market are piled high with fruits, vegetables, and flowers. “Look at all those colors,” Mom says. “It looks like a painting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at all those doughnuts.” I point to the stand. “I’m in heaven.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go there first.” Quinn looks up at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the lights turn, we hurry past eggplants, peppers, and zucchini to the table filled with doughnuts: glazed, sprinkled, chocolate, jelly-filled—every doughnut you can think of. Behind them, wearing a long apron, a baker’s hat, and her long hair in braids is the Doughnut Lady.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One glazed, one chocolate with sprinkles,” I order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s for you and Quinn, right?” Mom asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shake my head. “No, just for me. I’ve got to stock up. They might not have doughnuts at camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Quinn copies me and orders the same, and we munch away as we trail behind Mom, who picks out one vegetable after another. “Isn’t that your teacher, Mrs. Spanier?” Mom looks down the long row of tables.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end, Mrs. Spanier, who Gig and I call Snuffy, examines a cantaloupe and sets it back. “Yeah, let’s go the other way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely not, Jackson,” Mom says firmly. “It won’t kill you to go down and say hello to your teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s not my teacher anymore.” I lick chocolate off my finger. “She’s my ex-teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom gives me a poke in the back and I march forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Mrs. Spanier,” Mom calls out cheerfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, hello, Mrs. Kennedy.” Snuffy smiles. “How nice to see you. Jackson, are you enjoying your summer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” I wipe my hands on my cargo shorts and look down. Snuffy always makes me feel like I’ve done something wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And is this your little brother?” She bends down to Quinn’s eye level. “What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quinn,” he says louder than necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What a lovely name. What grade are you in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("“I’m going to be in first.” He holds up one finger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good for you. I hope I’m lucky enough to have you in fifth grade in a few years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jackson.” She stands up. “I was watching the ball game last night and thought about that story you wrote last spring about the baseball superhero. What was his name? Homerun Hero?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Homerunzilla.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was a great story. With ideas like that, you’ll do fine in middle school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh, thanks.” I’m shocked. Snuffy doesn’t give many compliments. Not to me anyway. While she and Mom share secrets for super-moist zucchini bread, I watch her. She’s got her regular pointed glasses, but her face looks more relaxed. She’s even smiling like a regular person. Maybe she likes summer better than school, too. Maybe she’s more like me than I ever imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('strong', [_c('em', [_vm._v("S")])])]), _vm._v("aturday afternoon, I meet Dad at the park for some soccer practice before camp. I sit on the bleachers tying the laces of my new cleats. Dad sits next to me stretching out his long legs. He’s got brown hair and green eyes like me, but his ears don’t stick out like mine. Maybe they won’t look so big when I’m older.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("“I picked up something for you.” Dad hands me a bag from Fat Tony’s Sport Mart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?” I open the bag and pull out two Under Armour shirts, a blue one and a gray one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re those wick-away shirts that move sweat away from the body. You might have some hot days up there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks.” I rub the fabric between my fingers. “I like them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good,” Dad says. “Let’s get started. An important part of soccer is stretching.” He raises his arms above his head. “It keeps you flexible and helps prevent injuries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sounds like Coach Wilkins from baseball, who always had us stretch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s do a few together.” Dad and I walk to the outfield grass. He sits down and stretches one leg in front of him and bends the other one back. He rubs his eyes. He looks tired from working late last night at his job as a chef. “Put your hands beside your leg and slowly bend down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I place my hands beside my knee and lean forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Use your breathing,” Dad says. “When you exhale, relax deeper into the stretch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He says stuff like this ever since he started taking yoga at the Y. I don’t really understand what he means, but I try to lean farther forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("“Relax,” Dad says. “Let gravity do some of the work of pulling you down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yeah, right. I bend my head and examine blades of grass. After we’ve finished stretching, we kick the ball around in the outfield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drive the ball with the instep of your foot.” Dad demonstrates a strong kick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you play varsity soccer in high school?” I chase the ball down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For a year,” Dad says. “Then I got a coach who was so intense that he took the fun out of it, so I quit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did your dad say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t like it.” Dad dribbles the ball. “But I wasn’t going to do something I didn’t want to. I just played for fun after that.” He boots a high bouncer and I stick my hand out to stop it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No hands,” Dad calls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. I know.” In all the games I love—baseball, football, basketball—you use your hands. Why would somebody invent a game where you can’t use your hands?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dad shows me how to use my foot to trap a bouncing ball. He shows me how to fake going one way and then go the other. He teaches me to do toe taps and circle toe taps so "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("that I touch the ball with the tip of one foot and then the other in a hoppity dance. “You’re a good athlete,” he says. “You’ll do fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But some of the kids at camp will have been playing soccer since they could stand up. I’ll be way behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry,” Dad says. “You’re there to have fun. It’s not a competition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s where he’s wrong. Once we get to camp, I’m sure it will be a competition.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81d967f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter002.vue
// module id = 72
// module chunks = 0